import BaseModel from '@/app-core/lib/data/model/BaseModel'
import ResetPasswordValidator from '@/app-core/api/validations/user/ResetPasswordValidator'
import ResetPasswordResource from '@/app-core/api/resources/user/ResetPasswordResource'
import API from '@/app-core/api/Api'

export default class ResetPasswordModel extends BaseModel {
  constructor(payload = {}, resource = ResetPasswordResource, validator = ResetPasswordValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
  async ResetPassword() {
    return await API.Resource.User.ResetPassword({email: this.Email})
  }
}
